<div class="policy bg-light">

    <div class="policy__container"
        [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header policy_paragraph">
            <h1>GESCHÄFTBEDINGUNGEN</h1>
            <h2>Regeln für die Erbringung der (elektronischen) Dienstleistungen
                im Rahmen einer mobilen Applikation</h2>
        </div>
        <div class="row"></div>
        <div class="policy_body>">
            <div class="policy_paragraph">
                <h2 id="Introduction">Einleitung</h2>
                <p class="content">
                    Die eModul-Applikation ist eine Webanwendung, die die Fernbedienung der Regler
                    ermöglicht, die mit den Modulen aus der Produktfamilie ST-505 und WIFI
                    zusammenarbeiten. Daher ist es notwendig geworden, die Funktionsweise der Web-App in
                    diesem Dokument zu definieren.
                </p>
            </div>

            <div class="policy_paragraph">
                <h2 id="ContractDetails">§ 1. Begriffsbestimmungen</h2>
                <div class="content">
                    Die unten aufgeführten Begriffe haben folgende Bedeutung:
                <ul class="policy-definitions">
                    <li>
                        <strong>Benutzername</strong> – E-Mail-Adresse des Benutzers für die Anmeldung im Konto
                    </li>
                    <li>
                        <strong>Passwort</strong> – eine Zeichenfolge, die gegen den unberechtigten Zugang zum Konto durch
                        andere Personen als der Kontobenutzer schützt.
                    </li>
                    <li>
                        <strong>Verbraucher</strong> – eine Person im Sinne von Art. 221 des Bürgerlichen Gesetzbuches von 23.
                        April 1964 (Gesetzblatt 2019 1145, konsolidierte Fassung von 19.06.2019).
                    </li>
                    <li>
                        <strong>Konto</strong> – Rechte und Pflichten, die dem Benutzer durch Registrierung und Vertragsabschluss
                        gewährt werden.
                    </li>
                    <li>
                        <strong>Datenschutz-Bestimmungen</strong> – ein von dem Dienstleister erstelltes Dokument, das die
                        Regeln zum Sammeln, Verarbeiten und Schutz der Daten, incl. personenbezogenen Daten
                        des Benutzers gemäß den Bestimmungen der Verordnung des Europäischen Parlaments und
                        des Rates (EU) 2016/79 vom 27. April 2016 zum Schutz natürlicher Personen bei
                        derVerarbeitung personenbezogenen Daten [der Europäischen Datenschutz-Grundverordnung ],
                        zum freien Verkehr solcher Daten und zur Aufhebung der Richtlinie 95/46/EG
                        (Datenschutz-Grundverordnung) im Zusammenhang mit der Erbringung von
                        Dienstleistungen im Rahmen des Services bestimmt.
                    </li>
                    <li>
                        <strong>Geschäftsbedingungen</strong> – diese Geschäftsbedingungen
                    </li>
                    <li>
                        <strong>Anmeldung</strong> – Vorgang der Erstellung eines individuellen Kontos für den Benutzer, der zum
                        Abschluss des Vertrags zwischen dem Anwender und Dienstleiter über Erbringung von
                        Dienstleistungen auf elektronischem Weg führt.
                    </li>
                    <li>
                        <strong>Service</strong> – Webseite zugänglich unter Adresse: https://emodul.pl und https://emodul.eu.
                    </li>
                    <li>
                        <strong>Vertrag</strong> – der gemäß den Geschäftsbedingungen ausgeführte Vertrag über Erbringung
                        elektronischer Dienstleistungen, zu dessen Abschlusses nach Beendigung des
                        Anmeldungsvorgangs kommt.
                    </li>
                    <li>
                        <strong>Dienstleistung oder Dienstleistungen</strong> – Dienstleistungen, die über den Service vom
                        Dienstleister an den Benutzer auf elektronischem Weg erbracht werden.
                    </li>
                    <li>
                        <strong>Dienstleister oder Auftragsverarbeiter</strong> – TECH STEROWNIKI spółka z ograniczoną
                        odpowiedzizalnością spółka komandytowa mit Sitz in Wieprz, Biała Droga Str. 31, 34-122
                        Wieprz, NIP [Steueridentifikationsnummer] 551 23 60 632, REGON [statistische Nummer]
                        356782780, KRS 0000594881. Kontaktdaten: poczta&#64;techsterowniki.pl, +48 33 330 00 07.
                    </li>
                    <li>
                        <strong>Authentifizierung</strong> - das Vorgehen zur Überprüfung der Identität aufgrund des
                        Benutzernamens und Passwortes.
                    </li>
                    <li>
                        <strong>Benutzer</strong> – eine erwachsene natürliche Person (mit Rechtsfähigkeit) , eine juristische
                        Person, eine Organisationseinheit ohne Rechtspersönlichkeit, die durch das Gesetz eine
                        Rechtspersönlichkeit bekommt.
                    </li>
                </ul>
                </div>
            </div>

            <div class="policy_paragraph">
                <h2 id="AboutEModul">§ 2. Allgemeine Bestimmungen</h2>
                <ol class="pp_list">
                    <li>
                        Die Geschäftsbedingungen regeln die Funktionsweise und Bedingungen für eine freiwillige
                        Nutzung des Services (einschl. Rechte und Pflichten des Dienstleisters und des Benutzers).
                    </li>
                    <li>
                        Die Nutzung der vom Dienstleister angebotenen Dienste setzt die vorherige Anerkennung
                        der Geschäftsbedingungen und die anschließende Einhaltung ihrer Bestimmungen voraus.
                    </li>
                    <li>
                        Die Dienste werden an einen unbegrenzten Kreis von Personen und Organisationen
                        gerichtet, die der grundlegenden Definition des Benutzers entsprechen.
                    </li>
                    <li>
                        Bei Zweifeln an der Auslegung von Bestimmungen der Geschäftsbedingungen soll sich der
                        Anwender oder die Person, die an der Nutzung der Dienste interessiert ist, an den
                        Dienstleister um Erläuterungen wenden.
                    </li>
                    <li>
                        Fragen zum Schutz personenbezogener Daten werden in der Datenschutzbestimmungen
                        festgelegt.
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 3. Anmeldungsverfahren im Rahmen des Services</h2>
                <ol class="pp_list">
                    <li>
                        Die Nutzung der Dienste im Rahmen des Services ist kostenlos. Die Einrichtung eines
                        Accounts im Anmeldungsverfahren ist gebührenfrei. Die Vertragsbeendigung und das Ende
                        der Nutzungsdauer des Dienstes ist kostenfrei. Der Dienstleister weist darauf hin, dass
                        während des Registrierungsvorgangs oder Nutzung des Services von Dritten (die nicht mit
                        dem Dienstleister verbunden sind) Gebühren erhoben werden können – z.B. von
                        Mobilfunkbetreibern, worauf der Dienstleister kein Einfluss hat.
                    </li>
                    <li>
                        Um ein individuelles Konto zu erstellen und Dienste zu nutzen, soll das Anmeldeformular,
                        verfügbar unter den folgenden Adressen, ausgefüllt werden: https://emodul.pl/registration oder https://emodul.eu/registration
                    </li>
                    <li>Für eine vollständige Einrichtung eines Kontos ist es notwendig:
                        <ol type="a" class="pp_list">
                            <li>einen individuellen Benutzernamen anzugeben,</li>
                            <li>ein persönliches Zugangspasswort zu erstellen (bestehend aus mindestens 8 Zeichen),</li>
                            <li>Datenschutzbestimmungen, verfügbar unter den folgenden Adressen:
                                <a href="/policy/emodul/de" target="_self" rel="noreferrer noopener">https://emodul.pl/policy/emodul/de</a>
                                oder
                                <a href="/policy/emodul/de" target="_self" rel="noreferrer noopener">https://emodul.eu/policy/emodul/de</a>
                                , zu lesen und anzunehmen,
                            </li>
                            <li>sich mit den Geschäftsbedingungen, verfügbar unter den Andressen:
                                <a href="/terms-of-service/emodul/de" target="_self" rel="noreferrer noopener">https://emodul.pl/terms-of-service/emodul/de</a>
                                oder
                                <a href="/terms-of-service/emodul/de" target="_self" rel="noreferrer noopener">https://emodul.eu/terms-of-service/emodul/de</a>
                                vertraut zu machen und sie anzunehmen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Im Falle von Problemen mit dem Funktionieren des Registrierformulars nehmen Sie
                        Kontakt mit dem Service unter der Adresse serwis&#64;techsterowniki.pl auf.
                    </li>
                    <li>
                        Der Anwender ist verpflichtet, wahrheitsgemäße Daten in der Registrierungsprozedur
                        anzugeben und haftet für Verletzung dieser Pflicht.
                    </li>
                    <li>
                        Nach dem Ausfüllen des Registrierungsformulars, einschl. dem Erfüllen von den im Absatz
                        3 erwähnten Anforderungen, erstellt der Benutzer ein vorübergehendes Konto, das durchden Link in
                        der Email vom Dienstleister bestätigt werden muss. Wenn Sie auf den
                        angegebenen Link klicken, wird der Registrierungsprozess erfolgreich abgeschlossen und ein
                        Konto erstellt. Wenn Sie den Registrierungsvorgang nicht durch Klicken auf den obigen Link
                        bestätigen, werden das vorübergehende Konto und alle Daten des potenziellen Benutzers
                        innerhalb von 24 Stunden ab dem Datum des Erhalts der E-Mail gelöscht (während dieser
                        Zeit wird der Dienstleister die Daten des potenziellen Benutzers in keiner Weise verwenden,
                        und der Vertrag gilt als nicht abgeschlossen).
                    </li>
                    <li>
                        Durch den erfolgreichen Abschluss des Registrierungsverfahrens, das zur Erstellung des
                        Kontos führt, kommt der Vertrag zustande.
                    </li>
                    <li>
                        Nach dem Ausfüllen vom Registrierungsformular und erfolgreicher Anmeldung richtet der
                        Dienstleister ein Benutzerkonto ein. Anschließend sendet er an den Anwender an die von
                        ihm bei der Registration angegebene E-Mail-Adresse einen Versuch, die Anmeldung zu
                        bestätigen. Diese E-Mail enthält auch die aktuelle Version der Geschäftsbedingungen. Diese
                        Bestätigung erfolgt durch Klick auf den in der E-Mail bereitgestellten Link. Mit dieser
                        Bestätigung wird die Anmeldung abgeschlossen.
                    </li>
                    <li>
                        Nach dem erfolgreichen Vertragsabschluss wird dem Benutzer über die angegebene
                        E-Mail-Adresse eine Nachricht geschickt, die den Vertragsabschluss bestätigt, und ein
                        Vertragsbeendigungsformular, mit dem der Benutzer den Vertrag kündigen kann. (Das
                        Formular enthält eine Anweisung für den Anwender über sein Kündigungsrecht).
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 4. Technische Voraussetzungen für eine effiziente Nutzung der Dienste</h2>
                <ol>
                    <li>Für eine ununterbrochene und korrekte Nutzung der Dienste braucht der Benutzer:
                        <ol type="a">
                            <li>einen festen Internetzugang,</li>
                            <li>einen Webbrowser, der Javascript und Cookies unterstützt,</li>
                            <li>ein E-Mail-Konto.</li>
                        </ol>
                    </li>
                    <li>
                        Der Anwender trägt die Verantwortung für die Sicherheit des Benutzernamens und des
                        Passwortes, und aller anderen im Service zur Verfügung gestellten Inhalte im Rahmen von
                        Tätigkeiten, die nur vom Benutzer ausgeführt werden können.
                    </li>
                    <li>
                        Um Informationen vor unbefugtem Zugriff zu schützen, sollte der Benutzer die üblichen
                        Schutzmaßnahmen gemäß dem Absatz 4 treffen d.h. Antivirenprogramme, komplizierte,
                        nicht wiederholbare Passwörter, Geheimhaltung der Daten.
                    </li>
                    <li>
                        Der Anwender erkennt, dass einige Geräte oder Software von Dritten keine sichere
                        Verbindungen mit dem zentralen, von dem Dienstleister verwendeten Gerät herstellen
                        können, deswegen trägt ausschließlich der Anwender das damit verbundene Risiko.
                    </li>
                    <li>
                        Der Dienstleister verwendet Sicherheitsmaßnahmen, kryptographische Techniken und
                        Lösungen, damit der Anwender den Service auf sichere Weise nutzen und Eingriffe Dritter in
                        seine Rechte vermeiden kann.
                    </li>
                    <li>
                        Der Dienstleister wendet die gebotene Sorgfalt an, um Dienste ununterbrochen und
                        ungestört zu erbringen.
                    </li>
                    <li>
                        Der Dienstleister haftet nicht für Probleme, Störungen und Unterbrechungen der Funktion
                        des Services oder der Dienste, und infolgedessen ein fehlerhaftes Funktionieren des Services
                        oder der Dienste, einschließlich unzulängliche Vertragserfüllung und ordnungswidrige
                        Bereitstellung von Diensten, wenn:
                        <ol type="a">
                            <li>solche Situation weniger als 15 Minuten am Tag dauert,</li>
                            <li>
                                solche Umstände durch den Verstoß des Anwenders oder Dritter gegen die
                                Geschäftsbedingungen verursacht werden.
                            </li>
                            <li>
                                solche Umstände durch Handlungen oder Unterlassungen Dritter verursacht werden, für
                                die der Dienstleister keine Verantwortung trägt, insbesondere als Folge von Internetausfall,
                                Hacker-Angriffen, Streiks, Verfügungen von hoher Hand, Naturkatastrophen oder
                                außergewöhnlichen Naturereignissen.
                            </li>
                            <li>
                                der Benutzer über solche Situation mindestens 24 Stunden im Voraus mit Angabe der
                                genauer Dauerzeit der Unterbrechung informiert wird.
                            </li>
                            <li>
                                die Ursachen solcher Situation auf der Seite der mit dem Anwender oder Dienstleister
                                zusammenarbeitenden Parteien liegen (z.B. Telekommunikationsdienstleister).
                            </li>
                        </ol>
                    </li>
                    <li>
                        Der Dienstleister kann nicht gewährleisten, dass die Geschäftsbedingungen durch andere
                        Benutzer eingehalten werden und trägt keine Verantwortung im Sinne Art. 14 des Gesetzes
                        von 18. Juli 2002 über elektronisch erbrachten Dienstleistungen – alle Einwände und
                        Meldungen sind an die Adresse: serwis&#64;techsterowniki.pl zu richten.
                    </li>
                    <li>
                        Der Dienstleister behält sich das Recht vor, den Service und die Dienste während der
                        Vertragslaufzeit zu verbessern oder zu ändern.
                    </li>

                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 5. Andere Voraussetzungen für die Nutzung der Dienste</h2>
                <ol>
                    <li>Der Benutzer erkennt, dass die Nutzung des Services freiwillig ist.</li>
                    <li>
                        Der Dienstleister analysiert in keiner Weise den Inhalt des Datenstroms, der durch den
                        Anwender vom Gerät an die eModul-App geschickt wird, daher trägt der Anwender die
                        alleinige Verantwortung für Art, Form, Inhalt dieser Daten (insbesondere für den Verstoß
                        gegen die geltenden Vorschriften)
                    </li>
                    <li>Der Benutzer ist verpflichtet, die Applikation gemäß den Vorschriften, im Rahmen guter
                        Sitten, ohne Verletzung der Persönlichkeitsrechte anderer Personen zu nutzen. Der
                        Dienstleister unterrichtet, dass es verboten ist, im Rahmen des Dienstes Maßnahmen zu
                        ergreifen, die gegen geltende Rechtsvorschriften oder gegen gute Sitten verstoßen,
                        insbesondere ist es verboten, folgende Inhalte zu verbreiten und zu veröffentlichen:
                        <ol type="a">
                            <li>obszöne und vulgäre Inhalte;</li>
                            <li>
                                Inhalte, die zum Hass insbesondere in Bezug auf Rasse, Geschlecht, Nationalität,
                                Staatsangehörigkeit, sexuelle Orientierung anregen, Inhalte, die religiöse Gefühle verletzen
                                oder Konfessionslosigkeit in Frage stellen;
                            </li>
                            <li>
                                Inhalte, die die Ideologie des Nationalsozialismus , des Kommunismus verbreiten und die
                                historische Wahrheit in Frage stellen;
                            </li>
                            <li>Inhalte, die sich gegen Persönlichkeitsrechte Dritter richten;</li>
                            <li>
                                die die Rechte des geistigen Eigentums verletzen, einschließlich Markenschutzrechte ,
                                Schutzrechte über sonstige Zeichen mit Unterscheidungskraft, sowie Urheberrechte und
                                verwandte Schutzrechte;
                            </li>
                            <li>Inhalte, die kriminelle Handlungen fördern oder darin unterweisen;</li>
                            <li>Inhalte, die das richtige Funktionieren der App gefährden könnten.</li>
                        </ol>
                    </li>
                    <li>
                        Der Benutzer haftet für seine Handlungen und Unterlassungen verbunden mit der
                        Nutzung der Applikation und Dienste, insbesondere haftet er für Schaden gegenüber dem
                        Dienstleister oder anderen Anwendern.
                    </li>
                    <li>Der Benutzer verpflichtet sich, keine Maßnahmen zu ergreifen, die das Funktionieren der
                        Applikation und Dienste beeinträchtigen könnten, insbesondere:
                        <ol type="a">
                            <li>keine schädliche Software (Viren) zu verwenden oder zu verbreiten,</li>
                            <li>den Service bestimmungsgemäß zu nutzen,</li>
                            <li>
                                einige oder alle Rechte und Pflichten bezüglich des Vertrags ohne ausdrückliche
                                Zustimmung des Dienstleisters auf keinen Dritten zu übertragen,
                            </li>
                            <li>
                                keine Maßnahmen zu ergreifen, um mit Hilfe des Services Zugang zu anderen von dem
                                Dienstleister oder von Dritten erbrachten Dienste auf rechtswidrige oder gegen die guten
                                Sitten verstoßene Weise zu bekommen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Der Dienstleister behält sich das Recht vor, das Konto / den Service eines bestimmten
                        Anwenders aufgrund eines Verstoßes gegen die Geschäftsbedingungen für einen von ihm
                        bestimmten Zeitraum zu sperren, sowie das Konto endgültig zu löschen.
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 6. Laufzeit</h2>
                <ol>
                    <li>Der Vertrag wird auf unbestimmte Zeit geschlossen.</li>
                    <li>
                        Der Anwender kann den Vertrag jederzeit ohne Angabe von Gründen kündigen, indem er
                        das Kündigungsformular an folgende Adresse: serwis&#64;techsterowniki.pl verschickt oder auf
                        jede andere Weise den Vertrag kündigt, unter der Voraussetzung, dass der Inhalt der
                        Willenserklärung gegenüber dem Dienstleister keinen Anlass zu Bedenken gibt .
                    </li>
                    <li>
                        Der Dienstleister ist zur Kündigung des Vertrags ohne Angabe vom Kündigungsgrund mit
                        einer Frist von 14 Tagen berechtigt.
                    </li>
                    <li>Der Dienstleister kann den Vertrag fristlos aus wichtigem Grund kündigen, insbesondere
                        im Falle:
                        <ol type="a">
                            <li>eines schwerwiegenden Verstoßes gegen die Geschäftsbedingungen,</li>
                            <li>mehrmaliges Verstoßes gegen die Geschäftsbedingungen (mindestens 3 Mal)</li>
                            <li>einer Inaktivität des Kontos (wenn in 12 aufeinanderfolgenden Monaten keine Aktivität
                                verzeichnet wird)</li>
                            <li>der Beendigung der Erbringung von Diensten für alle Anwender.</li>
                        </ol>
                    </li>
                    <li>
                        Die Kündigung des Vertrags ist gleichbedeutend mit der Auflösung des Vertrags,
                        der Löschung des Kontos und der fehlenden Möglichkeit zur Nutzung des Dienstes
                        sowie der gleichzeitigen Löschung von personenbezogenen Daten, sofern
                        in der Datenschutzerklärung oder zwingenden gesetzlichen Bestimmungen nichts anderes bestimmt ist.
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 7. Haftung des Dienstleisters</h2>
                <ol>
                    <li>
                        Die Haftung des Dienstleisters gegenüber dem Verbraucher ist durch geltende
                        Rechtsvorschriften geregelt und diese Geschäftsbedingungen beschränken diese Haftung
                        nicht.
                    </li>
                    <li>
                        In dem übrigen, nicht in dem Absatz 1 angegeben, Umfang ist die ganze Haftung des
                        Dienstleisters aus dem Vertrag und dem Service, im weitesten Sinne des Wortes
                        (unabhängig von der Rechtsgrundlage dieser Haftung), kumulativ:
                        <ol type="a">
                            <li>auf den durch vorsätzliches Fehlverhalten entstandenen Schaden begrenzt ,</li>
                            <li>auf die Höhe des tatsächlichen Schadens begrenzt.</li>
                        </ol>
                    </li>
                    <li>Außerdem ist die Haftung im Sinne des Absatzes 2 auf solche Art und Weise begrenzt,
                        dass der Dienstleiter nicht für Schäden haftet:
                        <ol type="a">
                            <li>die sich aus einer unsachgemäßen Vertragserfüllung oder Fehlfunktion der Anwendung
                                oder des Dienstes ergeben,</li>
                            <li>die durch den Verstoß des Anwenders oder der Dritten gegen die Geschäftsbedingungen
                                entstanden sind,</li>
                            <li>die mit dem Verlust von den in dem Service enthaltenen Daten verbunden sind,</li>
                            <li>die entgangenen Gewinn bilden.</li>
                        </ol>
                    </li>
                    <li>
                        Die Haftung aus der Gewährleistung im Sinne von Art. 556 ff.
                        des Polnischen Bürgerlichen Gesetzbuchs bleibt, vorbehaltlich Abs. 1, ausgenommen.
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 8. Beschwerden</h2>
                <ol>
                    <li>
                        Die Beschwerden über Dienstleistungen sind telefonisch unter der Nummer 33-875-93-80
                        oder per E-Mail an folgende Adresse serwis&#64;techsterowniki.pl einzureichen.
                    </li>
                    <li>Der Dienstleister prüft die Beschwerden innerhalb von 14 (vierzehn) Tagen nach ihrem Eingang.</li>
                    <li>Eine Antwort auf Beschwerde wird an die E-Mail-Adresse geschickt.</li>
                    <li>
                        Um die Beschwerde zu prüfen, kann der Anwender vom Dienstleister aufgefordert
                        werden, zusätzliche Daten anzugeben, die zur ordnungsgemäßen Identifizierung des
                        Anwenders oder des Problems erforderlich sind.
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 9. Rücktritt von dem Vertrag</h2>
                <ol>
                    <li>
                        Dem Anwender, der ein Verbraucher ist, steht das Recht zu, von dem Vertrag ohne
                        Angabe von Gründen innerhalb von 14 Tagen nach Vertragsabschluss (d.h. nach
                        Beendigung des Registrierungsvorgangs) zurückzutreten.
                    </li>
                    <li>
                        Zu diesem Zweck soll der Benutzer entsprechende Willenserklärung über Rücktritt vom
                        Vertrag dem Dienstleister so einreichen, damit der Inhalt ohne Zweifel an den Dienstleister
                        gelangt. Insbesondere kann der Anwender das Formular verwenden, das unter folgender Adresse
                        verfügbar ist:
                        <a href="/termination-form/emodul/de" target="_self" rel="noreferrer noopener">https://emodul.eu/termination-form/emodul/de</a>.
                    </li>
                    <li>
                        Um die im Absatz 1 genannte Frist einzuhalten, reicht es aus, die Mitteilung über
                        Ausübung des Rücktrittsrechts per Einschreiben an die Adresse des Dienstleisters oder per
                        E-Mail an die folgende Adresse serwis&#64;techsterowniki.pl zu schicken.
                    </li>
                    <li>
                        Der Rücktritt vom Vertrag und Vertragskündigung haben die gleiche Wirkung - der
                        Vertrag wird mit den im § 6 Absatz 5 der Geschäftsbedingungen beschriebenen Folgen
                        beendet.
                    </li>
                </ol>
            </div>

            <div class="policy_paragraph">
                <h2>§ 10. Schlussbestimmungen</h2>
                <ol>
                    <li>An die Geschäftsbedingungen findet das Recht der Republik Polen Anwendung.</li>
                    <li>
                        Das für Streitigkeiten aus diesem Vertrag zuständige Gericht ist das Gericht, das örtlich
                        für den Sitz des Dienstleisters zuständig ist. Die Streitigkeiten mit den Anwendern, die
                        Verbraucher sind, werden zu allgemeinen Bedingungen beigelegt. Der Anwender, der
                        Verbraucher ist, hat die Möglichkeit, eine außergerichtliche Rechtsbehelfsmethode vor Stały
                        Polubowny Sąd Konsumencki [Verbraucherschiedsgericht] bei Wojewódzki Inspektor
                        Inspekcji Handlowej [Inspekteur von Handelsaufsichtsbehörde ] in Warszawa zu nutzen.
                        Informationen zum Zugang zu dem Verfahren und Streitbeilegungsverfahren sind unter der
                        Adresse
                        <a href="https://uokik.gov.pl" rel="noreferrer noopener">https://uokik.gov.pl</a>
                        zu finden.
                    </li>
                    <li>Die Anlagen, die den Geschäftsbedingungen beigefügt sind, sind Bestandteil des Vertrags.</li>
                    <li>
                        Der Dienstleister behält sich das Recht vor, Änderungen der Geschäftsbedingungen
                        jederzeit, nach der früheren Unterrichtung 14 Tage im Voraus, vorzunehmen. Wird der
                        Benutzer die Änderungen der Geschäftsbedingungen zum Zeitpunkt ihres Inkrafttretens
                        nicht akzeptieren, hat er keine Möglichkeit die Dienste zu nutzen. Das Benutzerkonto bleibt
                        inaktiv, bis die aktuelle Version der Geschäftsbedingungen akzeptiert wird oder das Konto
                        vom Dienstleister gelöscht wird.
                    </li>
                    <li>Die Geschäftsbedingungen treten am 01.11.2019 in Kraft.</li>
                </ol>
            </div>
        </div>
    </div>

    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>
</div>

